module.exports = __webpack_public_path__ + "img/CHONG WEN BIN-PROCUREMENT.dabf8b26.jpg";